import React from 'react';
import './CircularProgress.scss';

const CircularProgress = ({ currentStep, totalSteps }) => {
  const radius = 18; // Updated radius for a 40px size
  const strokeWidth = 4;
  const circumference = 2 * Math.PI * radius; // Circumference of the circle
  const progress = (currentStep / totalSteps) * 100;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div className="progress-container">
      <div className="progress-circle">
        <svg className="circle" width="40" height="40"> {/* Set width and height to 40px */}
          <circle cx="20" cy="20" r={radius} strokeWidth={strokeWidth} stroke="#e6e6e6" fill="none" />
          <circle
            className="progress-ring"
            cx="20"
            cy="20"
            r={radius}
            strokeWidth={strokeWidth}
            stroke="#4db8ff"
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
          />
        </svg>
        <div className="step-count">
          <span className="current-step">{currentStep}</span>/<span className="total-steps">{totalSteps}</span>
        </div>
      </div>
    </div>
  );
};

export default CircularProgress;
